const Recipient = {
	BACKEND: 1,
	BROADCAST_BRIDGE_BACKEND: 2
};

export default Recipient;
